/**
 * @description : Format by 4 Characters and then space.
 * @param {String} trackingNumber - trackingNumber to format.
 * @returns {String} The formatted dynamic string.
 */
function splitNumberFilter() {

  return (trackingNumber) => {

    const textGroup = [];
    let i;
    let len;
    let filteredtrackingNumber = '';

    filteredtrackingNumber = trackingNumber.replace(/\s/g, '');

    for (i = 0, len = filteredtrackingNumber.length; i < len; i += 4) {

      textGroup.push(filteredtrackingNumber.substr(i, 4));

    }

    return textGroup.join(' ');

  };

}

export default splitNumberFilter;


// WEBPACK FOOTER //
// ./src/utils/splitNumber.filter.js